//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfImage from "~/themes/fiskarsMoominDefault/components/components/atoms/SfImage/SfImage.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import { useVSFContext } from '@vue-storefront/core';
import { useUiState } from "~/composables";
import { computed } from "@nuxtjs/composition-api";
export default {
  props: {
    iconOnly: {
      type: Boolean
    },
    inNavigation: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SfImage,
    SfButton,
  },
  setup() {
    const {
      i18n: { localeProperties },
    } = useVSFContext();


    const _selectedLocaleCountryName = computed(() => localeProperties.country);

    const { toggleCountrySelectorModal } = useUiState();

    return {
      localeProperties,
      toggleCountrySelectorModal,
      _selectedLocaleCountryName,
    };
  }
};
